import { z } from 'zod';

export const StateAbbreviation = z.enum([
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]);

// eNLC (enhanced Nurse Licensure Compact) participating states
export const ENLC_STATES = [
  'AL',
  'AZ',
  'AR',
  'CO',
  'DE',
  'FL',
  'GA',
  'ID',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MS',
  'MO',
  'MT',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NC',
  'ND',
  'OH',
  'OK',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
] as const;

export const StateLicenseOption = z.enum([...StateAbbreviation.options, 'Compact']);

export const ShiftType = z.enum(['Days', 'Nights', 'Flexible']);
